import { UnderwritingActivitySearchParams, UnderwritingActivitySearchResponse } from '@lio/api-types';
import { queryKeys, getUnderwritingActivityQuery } from '@services/underwritingReferral';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useSearchUnderwritingActivity = (params: UnderwritingActivitySearchParams) => {
  const query = getUnderwritingActivityQuery(params);

  const client = useClient();
  const result = useInfiniteQuery<UnderwritingActivitySearchResponse, Error>({
    queryKey: queryKeys.underwritingActivitySearchWithParams(params),
    queryFn: async ({ pageParam = 0 }) => {
      const response = await client
        .get(`underwriting-activity?${query}&pageOffset=${pageParam}`)
        .json<UnderwritingActivitySearchResponse>();
      return response;
    },
    initialPageParam: 0,
    placeholderData: (previousData) => previousData,
    staleTime: 15000,
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage?.pagination) return undefined;
      if (!lastPage.pagination.pageLimit) return undefined;
      if (!lastPage.pagination.total) return undefined;
      const { total, pageLimit } = lastPage.pagination;
      const fetchedPageCount = allPages.length;
      const nextPageOffsetValue = fetchedPageCount * pageLimit;
      if (nextPageOffsetValue > total) return undefined;
      return nextPageOffsetValue;
    },
  });
  return { ...result, underwritingActivity: result.data };
};
